import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "medical-menu-edit" }
const _hoisted_2 = { class: "edit-medical-menu-page main-content-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "メニュー登録", -1)

import MedicalMenuForm from "./components/common/form.vue";
import Trash from "@/clinic/components/trash.vue";
import { computed, inject, onBeforeMount, ref } from "vue";
import { useRoute } from "vue-router";
import { get, set } from "@vueuse/core";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import { MenuServices } from "@/clinic/services";
import { useToast } from "primevue/usetoast";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const route = useRoute();
const toast = useToast();
const clinicId = ref(0);

const idUrl = computed((): number => {
  const { params } = route;
  const { id } = params;
  return id as unknown as number;
});

const onTrash = async () => {
  await MenuServices.trashMenu(
    get(idUrl),
    {
      clinic_id: get(await get(clinicId)),
    },
    () => notifySuccessMsg(toast, "成功"),
    () => notityErrorMsg(toast, "エラー")
  );
};
onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(Trash, {
        id: _unref(get)(_unref(idUrl)),
        onTrash: onTrash
      }, null, 8, ["id"]),
      _createVNode(MedicalMenuForm, { hasEdit: "" })
    ])
  ]))
}
}

})